module.exports = __webpack_public_path__ + "static/media/telepizza@2x.757ce182.jpg";